/* ZeckenDad Theme JS */
(function() {
  // Shopify wraps each section. Making the header section sticky keeps the menu
  // available after the announcement bar has scrolled away.
  const siteHeader = document.querySelector('.tk-header');
  const headerSection = siteHeader ? siteHeader.closest('.shopify-section') : null;
  if (siteHeader && headerSection) {
    siteHeader.classList.add('tk-header--wrapped');
    headerSection.classList.add('tk-sticky-header-wrapper');
  }

  // Cart drawer toggle
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const toggles = document.querySelectorAll('[data-cart-toggle]');
  const closeBtn = document.querySelector('[data-cart-close]');

  function openCart(event) {
    if (!drawer) return;
    if (event) event.preventDefault();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
  }
  function closeCart() {
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    if (overlay) overlay.classList.remove('is-open');
  }
  toggles.forEach(t => t.addEventListener('click', openCart));
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  // Mobile navigation drawer
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');
  const menuOverlay = document.querySelector('[data-menu-overlay]');
  let menuReturnFocus = null;

  function openMobileMenu() {
    if (!mobileMenu || !menuToggle) return;
    menuReturnFocus = document.activeElement;
    mobileMenu.removeAttribute('inert');
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    menuToggle.setAttribute('aria-expanded', 'true');
    if (menuOverlay) menuOverlay.classList.add('is-open');
    document.documentElement.classList.add('tk-menu-open');
    window.requestAnimationFrame(() => {
      if (menuClose) menuClose.focus({ preventScroll: true });
    });
  }

  function closeMobileMenu() {
    if (!mobileMenu || !menuToggle) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileMenu.setAttribute('inert', '');
    menuToggle.setAttribute('aria-expanded', 'false');
    if (menuOverlay) menuOverlay.classList.remove('is-open');
    document.documentElement.classList.remove('tk-menu-open');
    if (menuReturnFocus && typeof menuReturnFocus.focus === 'function') {
      menuReturnFocus.focus({ preventScroll: true });
    }
    menuReturnFocus = null;
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileMenu);
  if (menuClose) menuClose.addEventListener('click', closeMobileMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMobileMenu);
  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMobileMenu));
    mobileMenu.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const focusable = Array.from(mobileMenu.querySelectorAll('a[href], summary, button:not([disabled])'));
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });

  const desktopMenuQuery = window.matchMedia('(min-width: 761px)');
  const closeMenuAtDesktop = event => {
    if (event.matches) closeMobileMenu();
  };
  if (desktopMenuQuery.addEventListener) {
    desktopMenuQuery.addEventListener('change', closeMenuAtDesktop);
  } else {
    desktopMenuQuery.addListener(closeMenuAtDesktop);
  }

  // Quantity stepper
  document.querySelectorAll('[data-qty-input]').forEach(input => {
    const wrap = input.parentElement;
    const minus = wrap.querySelector('[data-qty-minus]');
    const plus = wrap.querySelector('[data-qty-plus]');
    const display = wrap.querySelector('[data-qty-display]');

    function updateQty(nextValue) {
      const qty = Math.max(1, parseInt(nextValue || 1, 10) || 1);
      input.value = qty;
      if (display) display.textContent = qty;
    }

    updateQty(input.value);

    if (minus) minus.addEventListener('click', () => {
      updateQty((parseInt(input.value || 1, 10) || 1) - 1);
    });
    if (plus) plus.addEventListener('click', () => {
      updateQty((parseInt(input.value || 1, 10) || 1) + 1);
    });
  });

  // Variant pack selector — toggle is-active and update submit button
  document.querySelectorAll('.tk-pdp__form').forEach(form => {
    const submit = form.querySelector('[data-product-submit]');

    function updateSubmit(radio) {
      if (!submit || !radio) return;
      const available = radio.dataset.variantAvailable === 'true';
      const price = radio.dataset.variantPrice || '';
      submit.disabled = !available;
      submit.textContent = available ? `In den Warenkorb · ${price}` : 'Ausverkauft';
    }

    form.querySelectorAll('.tk-pack input[type="radio"]').forEach(r => {
      if (r.checked) updateSubmit(r);
      r.addEventListener('change', () => {
        form.querySelectorAll('.tk-pack').forEach(p => p.classList.remove('is-active'));
        const pack = r.closest('.tk-pack');
        if (pack) pack.classList.add('is-active');
        updateSubmit(r);
      });
    });
  });

  // Product gallery: desktop controls plus native horizontal swiping on mobile.
  function initProductGallery(gallery) {
    if (!gallery || gallery.dataset.productGalleryBound === 'true') return;

    const track = gallery.querySelector('[data-product-media-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-product-slide]'));
    const thumbsWrap = gallery.querySelector('.tk-pdp__thumbs');
    const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const current = gallery.querySelector('[data-gallery-current]');
    const mobileGallery = window.matchMedia('(max-width: 760px)');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!track || slides.length === 0) return;
    gallery.dataset.productGalleryBound = 'true';

    let activeIndex = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
    let scrollFrame = null;

    function updateGallery(nextIndex, options) {
      const settings = options || {};
      activeIndex = Math.max(0, Math.min(slides.length - 1, nextIndex));

      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      thumbs.forEach((thumb, index) => {
        const isActive = index === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (current) current.textContent = String(activeIndex + 1);
      if (previous) previous.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;

      if (settings.scrollTrack && mobileGallery.matches) {
        track.scrollTo({
          left: slides[activeIndex].offsetLeft,
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      }

      if (settings.scrollThumb && thumbsWrap && thumbs[activeIndex]) {
        const thumb = thumbs[activeIndex];
        const centeredLeft = thumb.offsetLeft - (thumbsWrap.clientWidth - thumb.clientWidth) / 2;
        thumbsWrap.scrollTo({
          left: Math.max(0, centeredLeft),
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      }
    }

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        updateGallery(index, { scrollTrack: true, scrollThumb: true });
      });
    });

    if (previous) {
      previous.addEventListener('click', () => {
        updateGallery(activeIndex - 1, { scrollTrack: true, scrollThumb: true });
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        updateGallery(activeIndex + 1, { scrollTrack: true, scrollThumb: true });
      });
    }

    track.addEventListener('scroll', () => {
      if (!mobileGallery.matches || scrollFrame !== null) return;
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = null;
        const slideWidth = track.clientWidth;
        if (slideWidth === 0) return;
        const visibleIndex = Math.round(track.scrollLeft / slideWidth);
        if (visibleIndex !== activeIndex) {
          updateGallery(visibleIndex, { scrollThumb: true });
        }
      });
    }, { passive: true });

    track.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      updateGallery(activeIndex + direction, { scrollTrack: true, scrollThumb: true });
    });

    updateGallery(activeIndex);
  }

  document.querySelectorAll('.tk-pdp__gallery').forEach(initProductGallery);

  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.tk-pdp__gallery').forEach(initProductGallery);
  });

  // Demo video modal — Shopify-hosted videos only
  function openDemoVideoModal(modal) {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDemoVideoModal(modal) {
    const nativeHost = modal.querySelector('[data-demo-native-host]');
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (nativeHost) {
      nativeHost.innerHTML = '';
      nativeHost.hidden = true;
    }
    document.documentElement.style.overflow = '';
  }

  function initDemoVideoModal(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-demo-video-open]').forEach(btn => {
      if (btn.dataset.demoVideoBound === 'true') return;
      btn.dataset.demoVideoBound = 'true';
      btn.addEventListener('click', () => {
        const section = btn.closest('section');
        const modal = section ? section.querySelector('[data-demo-modal]') : document.querySelector('[data-demo-modal]');
        const nativeHost = modal ? modal.querySelector('[data-demo-native-host]') : null;
        const template = btn.querySelector('[data-demo-native-template]');
        if (!modal || !nativeHost || !template) return;
        nativeHost.innerHTML = template.innerHTML;
        nativeHost.hidden = false;
        openDemoVideoModal(modal);
        const video = nativeHost.querySelector('video');
        if (video) {
          video.setAttribute('controls', 'controls');
          video.play().catch(() => {});
        }
      });
    });
  }

  function bindDemoVideoModalClosers(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-demo-close]').forEach(btn => {
      if (btn.dataset.videoCloseBound === 'true') return;
      btn.dataset.videoCloseBound = 'true';
      btn.addEventListener('click', () => {
        const modal = btn.closest('[data-demo-modal]');
        if (modal) closeDemoVideoModal(modal);
      });
    });
  }

  initDemoVideoModal(document);
  bindDemoVideoModalClosers(document);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-demo-modal].is-open').forEach(closeDemoVideoModal);
    }
  });
  document.addEventListener('shopify:section:load', event => {
    initDemoVideoModal(event.target);
    bindDemoVideoModalClosers(event.target);
    bindStoryDetails(event.target);
  });

  function bindStoryDetails(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-story-details]').forEach(details => {
      if (details.dataset.storyDetailsBound === 'true') return;
      details.dataset.storyDetailsBound = 'true';

      const summary = details.querySelector('summary');
      if (!summary) return;

      let summaryTop = null;

      function rememberSummaryPosition() {
        summaryTop = summary.getBoundingClientRect().top;
      }

      summary.addEventListener('click', rememberSummaryPosition);
      summary.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') rememberSummaryPosition();
      });

      details.addEventListener('toggle', () => {
        if (!details.open || summaryTop === null) {
          summaryTop = null;
          return;
        }

        window.requestAnimationFrame(() => {
          const nextTop = summary.getBoundingClientRect().top;
          if (Math.abs(nextTop - summaryTop) > 1) {
            window.scrollBy({ top: nextTop - summaryTop, left: 0, behavior: 'auto' });
          }
          summaryTop = null;
        });
      });
    });
  }

  bindStoryDetails(document);

  // FAQ — uses native <details>
})();
